import React from "react";
import { Provider } from "react-redux";
import store from "./src/state/store";
import "./src/styles/global.scss";

export const wrapRootElement = ({ element }) => {
  return <Provider store={store}>{element}</Provider>;
};

// Scroll to top on route change
export const onRouteUpdate = ({ location, prevLocation }) => {
  if (prevLocation && prevLocation.pathname !== location.pathname) {
    window.scrollTo(0, 0);
  }
};
